import { FETCH_SUBSCRIPTIONS } from 'email-management-lib/refactor/actions/actionTypes';
const initialState = [];
export default function subscriptions(state = initialState, action) {
  switch (action.type) {
    case FETCH_SUBSCRIPTIONS:
      return action.payload;
    default:
      return state;
  }
}